// @flow

import React, { memo, useCallback } from 'react';

import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import { CropType, CropTypeColor } from 'js/constants/CropConstants';
import MenuItem from '@mui/material/MenuItem';
import { ListItemIcon, ListItemText } from '@mui/material';
import Box from '@mui/material/Box';
import { useLangFile } from 'js/context/LanguageContext';

import Styles from './SelectCrop.module.less';
import clsx from 'clsx';
import { red } from '@mui/material/colors';

const SelectCrop = (props: SelectCrop.propTypes) => {
  const LangFile = useLangFile();

  const onCropChanged = useCallback(
    (event) => {
      props.onChanged(event.target.value);
    },
    [props.onChanged]
  );

  return (
    <FormControl fullWidth={true} error={props.error}>
      <InputLabel shrink={true} style={{ marginLeft: '-13px' }}>
        {LangFile.SelectCrop.label}
      </InputLabel>
      <Select
        classes={{
          root: clsx({ [Styles.SelectRoot]: true, [Styles.SelectRootError]: props.error }),
          icon: clsx({ [Styles.IconError]: props.error }),
        }}
        fullWidth={true}
        error={props.error}
        value={props.value}
        renderValue={(value) => {
          return (
            <Box
              sx={{
                color: value === CropType._SELECT ? red['A700'] : 'black',
              }}
            >
              {LangFile.CropType[value]}
            </Box>
          );
        }}
        onChange={onCropChanged}
        variant={'standard'}
      >
        {Object.keys(CropType).map((crop) => {
          let color = CropTypeColor[crop];

          return (
            <MenuItem className={Styles.MenuItem} value={crop} key={crop}>
              {color && (
                <ListItemIcon className={Styles.ListItemIcon}>
                  <Box
                    sx={{
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      border: 2,
                      borderColor: 'grey.900',
                      bgcolor: CropTypeColor[crop],
                    }}
                  />
                </ListItemIcon>
              )}

              <ListItemText className={clsx({ [Styles.ListItemText]: true })}>
                {LangFile.CropType[crop]}
              </ListItemText>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

SelectCrop.propTypes = {
  onChanged: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.bool,
};

export default memo(SelectCrop);
